import React, { useEffect, useState } from "react";
import classnames from "classnames";

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  InputGroup,
} from "reactstrap";

// components
import AppSimpleBar from "./AppSimpleBar";
import EmptyStateResult from "./EmptyStateResult";

//utils
import { DivideByKeyResultTypes, divideByKey } from "../utils";

// interfaaces

import { useContacts } from "../context/ContactsContext";
import { IUser } from "../types/user";
import { IContact } from "../types/contacts";

interface ContactItemProps {
  contact: IUser;
  selected: boolean;
  onSelectContact: (id: string | number, selected: boolean) => void;
}
const ContactItem = ({
  contact,
  selected,
  onSelectContact,
}: ContactItemProps) => {
  const fullName = `${contact.name}`;
  const onClick = () => {
    onSelectContact(contact.id, !selected);
  };

  return (
    <li className={classnames({ selected: selected })} onClick={onClick}>
      <div>
        <h5 className="font-size-14 m-0">{fullName}</h5>
      </div>
    </li>
  );
};

interface CharacterItemProps {
  letterContacts: DivideByKeyResultTypes<IContact>;
  index: number;
  totalContacts: number;
  selectedContacts: Array<number | string>;
  onSelectContact: (id: string | number, selected: boolean) => void;
}
const CharacterItem = ({
  letterContacts,
  index,
  totalContacts,
  selectedContacts,
  onSelectContact,
}: CharacterItemProps) => {
  return (
    <div className={classnames({ "mt-3": index !== 0 })}>
      <div className="contact-list-title">{letterContacts.letter}</div>

      <ul
        className={classnames("list-unstyled", "contact-list", {
          "mb-0": index + 1 === totalContacts,
        })}
      >
        {(letterContacts.data || []).map((contact: any, key: number) => {
          const selected: boolean = selectedContacts.includes(contact.id);
          return (
            <ContactItem
              contact={contact}
              key={key}
              selected={selected}
              onSelectContact={onSelectContact}
            />
          );
        })}
      </ul>
    </div>
  );
};

interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddContact: (contactsAdd: Array<string | number>) => void;
}

const ContactModal = ({ isOpen, onClose, onAddContact }: ContactModalProps) => {
  const { contacts, error, loading, getContacts } = useContacts();
  const [contactsData, setContactsData] = useState<Array<any>>([]);
  const totalC = (contacts || []).length;

  useEffect(() => {
    // console.log("[ContactsPage] useEffect chamado → getContacts()");
    getContacts();
  }, [getContacts]);

  useEffect(() => {
    if (contacts.length > 0) {
      const formattedContacts = divideByKey("name", contacts);
      setContactsData(formattedContacts);
    }
  }, [contacts]);



  // global store
  // const { useAppSelector } = useRedux();
  // const { contactsList } = useAppSelector(state => ({
  //   contactsList: state.Contacts.contacts,
  // }));



  // const errorData = createSelector(
  //   (state: any) => state.Contacts,
  //   (state) => ({
  //     contactsList: state.contacts,
  //   })
  // );
  // Inside your component
  //const { contactsList } = useAppSelector(errorData);

  /*
  contacts hook
  */


  /*
  contact search
  */
  const [search, setSearch] = useState("");
  const onChangeSearch = (value: string) => {
    setSearch(value);
    let modifiedContacts = [...contacts];
    let filteredContacts = (modifiedContacts || []).filter((c: any) =>
      c["name"].toLowerCase().includes(value.toLowerCase())
    );
    const formattedContacts = divideByKey("name", filteredContacts);
    setContactsData(formattedContacts);
  };



  /*
  select contacts
  */
  const [selectedContacts, setSelectedContacts] = useState<
    Array<string | number>
  >([]);
  const onSelectContact = (id: string | number, selected: boolean) => {
    let modifiedList: Array<string | number> = [...selectedContacts];
    if (selected) {
      modifiedList = [...modifiedList, id];
    } else {
      modifiedList = modifiedList.filter(m => m + "" !== id + "");
    }
    setSelectedContacts(modifiedList);
  };

  /*
  disale button
  */
  // const disabled = selectedContacts.length === 0;

  /*
  submit data
  */
  const onSubmit = () => {
    onAddContact(selectedContacts);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      tabIndex={-1}
      centered
      className="contactModal"
    >
      <ModalHeader toggle={onClose} className="bg-primary">
        <div className="modal-title modal-title-custom text-white font-size-16 bg-primary ">
          Contatos
        </div>
      </ModalHeader>
      <ModalBody className="p-4">
        <InputGroup className="mb-4">
          <Input
            type="text"
            className="form-control bg-light border-0 pe-0"
            placeholder="procurar.."
            aria-label="Example text with button addon"
            aria-describedby="contactSearchbtn-addon"
            value={search || ""}
            onChange={(e: any) => {
              onChangeSearch(e.target.value);
            }}
          />
          <Button color="light" type="button" id="contactSearchbtn-addon">
            <i className="bx bx-search align-middle"></i>
          </Button>
        </InputGroup>

        {totalC === 0 ? (
          <EmptyStateResult searchedText={search} />
        ) : (
          <>
            <div className="d-flex align-items-center px-1">
              <div className="flex-grow-1">
                <h4 className=" font-size-11 text-muted text-uppercase">
                  Contacts
                </h4>
              </div>
            </div>
            <AppSimpleBar
              className="contact-modal-list mx-n4 px-1"
              style={{ maxHeight: "200px" }}
            >
              <>
                {(contactsData).map(
                  (letterContacts: DivideByKeyResultTypes<IContact>, key: number) => (
                    <CharacterItem
                      letterContacts={letterContacts}
                      key={key}
                      index={key}
                      totalContacts={totalC}
                      selectedContacts={selectedContacts}
                      onSelectContact={onSelectContact}
                    />
                  )
                )}

              </>
            </AppSimpleBar>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button type="button" color="link" onClick={onClose}>
          Cancel
        </Button>
        <Button
          type="button"
          color="primary"
          // disabled={disabled}
          onClick={onSubmit}
        >
          <i className="bx bxs-send align-middle"></i>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ContactModal;
